export default function activeFilter() {
    return function (input) {
        var f = [], i, j;
        for (i = 0; i < input.length; i++) {
            for (j = 0; j < input[i].options.length; j++) {
                if (input[i].options[j].active === true && input[i].field.indexOf('_') !== 0) {
                    f.push(input[i]);
                }
            }
        }
        return f;
    }
};